<p-dialog header="Select a payment method" [(visible)]="visible" [modal]="true" [style]="{ width: '30vw' }"
    [draggable]="false" [resizable]="false" (onHide)="onClose()">
    <div class="dialog-content">
        <div *ngIf="loadingCards" class="loading-wrapper">
            <p>Loading credit cards</p>
            <div class="spinner-border loading"></div>
        </div>
        <ng-container *ngIf="!paymentInProgress">
            <div class="credit-card" *ngFor="let card of cards; index as indexNumber"
                [ngClass]="{'active' : selectedCard === card}" (click)="onSelectCard(card)">
                <img src="../../../../assets/images/cards/visa.svg" *ngIf="card.brand === 'Visa'" class="card-brand">
                <img src="../../../../assets/images/cards/mastercard.svg" *ngIf="card.brand !== 'Visa'"
                    class="card-brand">
                <div class="texts-wrapper">
                    <p class="card-holder">{{ card.customer }}</p>
                    <p class="card-number">**** {{ card.last4 }}</p>
                </div>
                <div class="selected-icon" *ngIf="selectedCard === card"><i class="bi bi-check2"></i></div>
            </div>
        </ng-container>
        <div *ngIf="paymentInProgress" class="loading-wrapper">
            <p>Processing the payment</p>
            <div class="spinner-border loading"></div>
        </div>
    </div>
    <div class="dialog-footer">
        <button *ngIf="!paymentInProgress" class="continue-button" (click)="onPay()" [disabled]="!selectedCard">Pay {{
            order?.price }} USD</button>
    </div>
</p-dialog>